import { render, staticRenderFns } from "./GlobalTop10SwiperSlide.vue?vue&type=template&id=8e6d0a86&scoped=true"
import script from "./GlobalTop10SwiperSlide.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalTop10SwiperSlide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalTop10SwiperSlide.vue?vue&type=style&index=0&id=8e6d0a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6d0a86",
  null
  
)

export default component.exports